// extracted by mini-css-extract-plugin
module.exports = {"reportWrapper":"V9UudO7J4f7ZZeqyitysH"};